import { render, staticRenderFns } from "./BaseFormPhone.vue?vue&type=template&id=654dc337"
import script from "./BaseFormPhone.vue?vue&type=script&lang=ts"
export * from "./BaseFormPhone.vue?vue&type=script&lang=ts"
import style0 from "./BaseFormPhone.vue?vue&type=style&index=0&id=654dc337&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports